import { Map, ScrollText, Dices, MessageSquare, Lock } from "lucide-react";

const TABS = [
  { id: "map", label: "Map", icon: Map },
  { id: "sheet", label: "Sheet", icon: ScrollText },
  { id: "dice", label: "Dice", icon: Dices },
  { id: "chat", label: "Chat", icon: MessageSquare },
  { id: "whispers", label: "Whisper", icon: Lock },
];

export default function BottomNav({ active, onChange, alertTabId }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-black/70 backdrop-blur-2xl border-t border-white/10 grid grid-cols-5" data-testid="mobile-bottom-nav">
      {TABS.map((t) => (
        <button
          key={t.id}
          data-testid={`bottom-nav-${t.id}`}
          onClick={() => onChange(t.id)}
          className={`relative flex flex-col items-center gap-1 py-3 min-h-14 transition-colors duration-200 ${
            active === t.id ? "text-[#D4AF37]" : alertTabId === t.id ? "text-[#D90429] animate-pulse" : "text-[#f1e0c5]/50"
          }`}
        >
          <t.icon className="w-5 h-5" />
          <span className="text-[10px] uppercase tracking-wider">{t.label}</span>
          {alertTabId === t.id && <span data-testid="bottom-nav-alert-dot" className="absolute top-1.5 right-[calc(50%-14px)] w-2 h-2 rounded-full bg-[#D90429] shadow-[0_0_6px_#D90429]" />}
        </button>
      ))}
    </nav>
  );
}
